module.exports = __webpack_public_path__ + "static/img/React.7701856b.png";